export const PHOTO_DRAWER_DEFAULT_VALUES = {
  selectedImageIds: [],
  imagesUploaded: false,
};
